import createIcon from '../../createIcon';

/**
 * @component @name MarkEmailRead
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNSAxOEMxMS41IDE0LjEzIDE0LjYzIDExIDE4LjUgMTFDMTkuNTggMTEgMjAuNTkgMTEuMjUgMjEuNSAxMS42OFY1QzIxLjUgMy45IDIwLjYgMyAxOS41IDNIMy41QzIuNCAzIDEuNSAzLjkgMS41IDVWMTdDMS41IDE4LjEgMi40IDE5IDMuNSAxOUgxMS41OEMxMS41MyAxOC42NyAxMS41IDE4LjM0IDExLjUgMThaTTMuNSA1TDExLjUgMTBMMTkuNSA1VjdMMTEuNSAxMkwzLjUgN1Y1Wk0xNi44NCAyMUwxMy4zIDE3LjQ2TDE0LjcxIDE2LjA1TDE2LjgzIDE4LjE3TDIxLjA3IDEzLjkzTDIyLjUgMTUuMzRMMTYuODQgMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MarkEmailRead = createIcon('MarkEmailRead', [
  [
    'path',
    {
      d: 'M11.5 18C11.5 14.13 14.63 11 18.5 11C19.58 11 20.59 11.25 21.5 11.68V5C21.5 3.9 20.6 3 19.5 3H3.5C2.4 3 1.5 3.9 1.5 5V17C1.5 18.1 2.4 19 3.5 19H11.58C11.53 18.67 11.5 18.34 11.5 18ZM3.5 5L11.5 10L19.5 5V7L11.5 12L3.5 7V5ZM16.84 21L13.3 17.46L14.71 16.05L16.83 18.17L21.07 13.93L22.5 15.34L16.84 21Z',
      key: 'fwlbr4',
    },
  ],
]);

export default MarkEmailRead;
